module.exports = __webpack_public_path__ + "96744df192121b1c825d69e36fe19341.pdf";